// src/composables/useSessionWatcher.js

import { ref, onUnmounted } from 'vue';

const SESSION_CHECK_INTERVAL = parseInt(process.env.VUE_APP_SESSION_CHECK_INTERVAL || 60000); // Default to 1 minute

export function useSessionWatcher() {
  const intervalId = ref(null);
  const isChecking = ref(false);

  const checkSession = async () => {
    if (isChecking.value) return;
    isChecking.value = true;

    try {
      const { default: ApiClient } = await import('@/api/ApiClient');
      
      const apiClient = new ApiClient('api/auth/');
      const response = await apiClient.executeRequest('/validate', {}, apiClient.methods.GET);

      if (!response.success()) {
        stopWatcher();
      }
    } catch (err) {
      console.error('[SessionWatcher] Error checking session:', err);
    } finally {
      isChecking.value = false;
    }
  };

  const startWatcher = () => {
    if (intervalId.value) return;
    checkSession();
    intervalId.value = setInterval(checkSession, SESSION_CHECK_INTERVAL);
  };

  const stopWatcher = () => {
    if (intervalId.value) {
      clearInterval(intervalId.value);
      intervalId.value = null;
    }
  };

  onUnmounted(() => stopWatcher());

  return { startWatcher, stopWatcher };
}